/* global axios */
import ApiClient from './ApiClient';

const buildParams = params =>
  new URLSearchParams(
    Object.entries(params).filter(
      ([, value]) => value !== undefined && value !== ''
    )
  ).toString();

class SocialPostsAPI extends ApiClient {
  constructor() {
    super('social_posts', { accountScoped: true });
  }

  get(params = {}) {
    const { inboxId, scheduled, page = 1 } = params;
    const requestURL = `${this.url}?${buildParams({
      inbox_id: inboxId,
      scheduled,
      page,
    })}`;
    return axios.get(requestURL);
  }

  update(id, { message, scheduledAt }) {
    return axios.patch(`${this.url}/${id}`, {
      message,
      scheduled_at: scheduledAt,
    });
  }

  generate({ brief }) {
    return axios.post(`${this.url}/generations`, { brief });
  }

  generateImagePrompt({ brief }) {
    return axios.post(`${this.url}/image_prompt`, { brief });
  }
}

export default new SocialPostsAPI();
